<div class="breadcrumb-wrapper" *ngIf="hasCrumbs">
  <div [ngClass]="{'container-fluid': fullWidthView$ | async, 'container': !(fullWidthView$ | async)}">
    <div class="row">
      <div class="col-12">
        <ul class="breadcrumb" *ngIf="staticCrumbs && hasCrumbs">
         
          <li *ngFor="let crumb of staticCrumbs;let last = last" class="breadcrumb-item" [ngClass]="{ 'active': last && onlyStatic }">
            <a [routerLink]="crumb.slug">
              <i class="fa fa-home" *ngIf="crumb?.slug === '/home'"></i>
              {{ crumb?.slug === '/home' ? '' : crumb?.name }}
            </a>
          </li>

          <li class="breadcrumb-item" *ngFor="let crumb of crumbs;let i = index;let last = last" [ngClass]="{ 'active': last }">
            <a [routerLink]="crumb.slug">
              <i class="fa fa-home" *ngIf="crumb?.slug === '/home'"></i>
              {{ crumb?.slug === '/home' ? '' : crumb?.name }}
            </a>
          </li>
          
        </ul>
      </div>
    </div>
  </div>
</div>

